import React, { memo, useState, useEffect } from 'react'
import { useLocation } from '@reach/router'
import SMSSent from './SMSSentPage'
import LinkExpired from './LinkExpiredPage'
import SomethingWrongPage from './SomethingWrongPage'
import Spinner from '../dsr/common/dsr-spinner'
import { RETRIGGER_PASSWORD_API } from '../../constants/constants'
import { serverData } from '../../utils'
import { get } from '../../utils/ajax.js'

const useQuery = (queryParam) => {
  const search = new URLSearchParams(useLocation().search)
  return search.get(queryParam)
}

const StatusContent = memo((props) => {
  const [currentState, setCurrentState] = useState('SPINNER')
  const [apiresponse, setResponse] = useState({})

  const token = useQuery('token')
  useEffect(() => {
    const reqparams = {
      _csrf: serverData._csrf,
      verificationToken: token || '',
    }
    postSMSPasswordRequest(reqparams)
  }, [])

  async function postSMSPasswordRequest(reqparams) {
    const response = await get(
      `${RETRIGGER_PASSWORD_API}?token=${reqparams.verificationToken}`,
    )
    if (response && response.data && response.data.status) {
      setCurrentState(response.data.status)
      const resData = response.data
      setResponse({ ...apiresponse, ...resData })
    } else {
      setCurrentState('SOMETHINGWRONG')
    }
  }

  const updateState = (state) => {
    setCurrentState(state)
  }
  const showState = (state) => {
    const DAR_STATES = {
      SENT: (
        <SMSSent changeState={updateState} {...props} response={apiresponse} />
      ),
      LINK_EXPIRED: <LinkExpired changeState={updateState} {...props} />,
      SOMETHINGWRONG: (
        <SomethingWrongPage changeState={updateState} {...props} />
      ),
      SPINNER: <Spinner />,
    }
    return DAR_STATES[state]
  }

  return <>{showState(currentState)}</>
})
StatusContent.displayName = 'StatusContent'

export default StatusContent
